module.exports = __webpack_public_path__ + "detail1.2111734f.png";